import React from "react";
import Modal from "../Modal";
import { format } from "date-fns";

export type ReceiptSlipData = {
  patientName: string;
  receiptNumber: string;
  invoiceNumber: string;
  paymentDate: string | null;
  paymentMode: string;
  amount: number;
  clinicName?: string;
  notes?: string | null;
};

type ReceiptSlipModalProps = {
  isOpen: boolean;
  onClose: () => void;
  receiptData: ReceiptSlipData | null;
};

const ReceiptSlipModal: React.FC<ReceiptSlipModalProps> = ({
  isOpen,
  onClose,
  receiptData,
}) => {
  const handlePrint = () => {
    window.print();
  };

  if (!isOpen) return null;

  if (!receiptData) return null;

  const data = receiptData;

  return (
    <Modal
      title="View Receipt"
      onClose={onClose}
      width="sm:max-w-md"
      modalContent={
        <div className="receipt-slip-modal-content">
          <div className="receipt-slip-print-area bg-white p-4 border border-gray-200 rounded-lg">
            <div className="text-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                {data.clinicName || "Payment Receipt"}
              </h3>
              <p className="text-sm text-gray-500 mt-1">Payment Slip</p>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Patient:</span>
                <span className="font-medium">{data.patientName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Receipt No:</span>
                <span className="font-medium">{data.receiptNumber}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Invoice No:</span>
                <span className="font-medium">{data.invoiceNumber}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Date:</span>
                <span className="font-medium">
                  {data.paymentDate
                    ? format(new Date(data.paymentDate), "dd MMM yyyy")
                    : "-"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Payment Mode:</span>
                <span className="font-medium">{data.paymentMode}</span>
              </div>
              <div className="flex justify-between pt-2 border-t border-gray-200">
                <span className="text-gray-600 font-medium">Amount:</span>
                <span className="font-bold text-lg">₹{data.amount}</span>
              </div>
              {data.notes && (
                <div className="pt-2 text-gray-600 text-xs">
                  Notes: {data.notes}
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-4 print:hidden">
            <button
              type="button"
              onClick={handlePrint}
              className="px-4 py-2 text-sm font-semibold text-white rounded-md bg-primary hover:bg-hover"
            >
              Print
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-semibold text-gray-700 rounded-md border border-gray-300 hover:bg-gray-50"
            >
              Close
            </button>
          </div>
        </div>
      }
    />
  );
};

export default ReceiptSlipModal;
